import ReactGA from 'react-ga';

export const initGa = () => {
	ReactGA.initialize('UA-65225340-1');
};

export const GApageView = (page: any) => {
	ReactGA.pageview(page);
};
